import React from "react";
import { useTranslation } from "i18n";
import { getCheckoutLink } from "helpers/getCheckoutLink";
import { checkIsCD, oidcLogout } from "shared-auth";
import { ReactComponent as InfoIconSvg } from "component-library/src/images/svg/icons/warning-icon-base.svg";
import applicationMap, { CheckoutType } from "services/applicationMap";
import { useValidAddressOrRedirectAction } from "../hooks/useValidAddressOrRedirectAction";
import { IBillingApiResponse } from "services/api/BillingApi/BillingApi";
import NotificationBanner from "../NotificationBanner";

interface Props {
  performerSubscriptionData?: IBillingApiResponse;
}

const ReactivateSubscriptionBanner = ({ performerSubscriptionData }: Props) => {
  const { t } = useTranslation();

  const { address, subscription } = performerSubscriptionData || {};

  const reactivationRedirect = getCheckoutLink({
    planCode: subscription?.planCode,
    checkoutType: CheckoutType.Reactivation,
  });

  const returnPath = checkIsCD()
    ? applicationMap.routes.index()
    : reactivationRedirect;

  const handleRenew = useValidAddressOrRedirectAction({
    address,
    redirect: reactivationRedirect,
    returnPath,
  });

  return (
    <NotificationBanner
      messageHtml={t("common:banner.reactivation.message")}
      buttons={[
        {
          title: t("common:nav.signout"),
          text: t("common:nav.signout"),
          href: "/",
          type: "secondary",
          onClick: oidcLogout,
        },
        {
          title: t("common:button.label.reactivateNow"),
          text: t("common:button.label.reactivateNow"),
          href: reactivationRedirect,
          onClick: handleRenew,
        },
      ]}
      icon={
        <InfoIconSvg
          width={24}
          height={24}
          className="mr-2 text-color-brand-one"
        />
      }
    />
  );
};

export default ReactivateSubscriptionBanner;
